import React from 'react';
import LineBreakText from './lineBreakText.jsx';
import ResizingTextarea from './resizingTextarea.jsx';
import classNames from 'classnames';
import CellHelper from 'main/components/show/cuesheet/cellHelper';

const markdownOptions = CellHelper.getMarkdownOptions();

/**
 * Editable cell
 *
 */
export default React.createClass({
  displayName: 'EditableCell',

  propTypes: {
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    extraClassName: React.PropTypes.string,
    onSelect: React.PropTypes.func.isRequired,
    onStartEdit: React.PropTypes.func.isRequired,
    onStopEdit: React.PropTypes.func.isRequired,
    resizeWhenEditing: React.PropTypes.bool,
    text: React.PropTypes.string,
    allowMarkdown: React.PropTypes.bool,
    format: React.PropTypes.object,
    placeholder: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      resizeWhenEditing: true,
      allowMarkdown: false,
      placeholder: '',
    };
  },

  render() {
    const { isEditing, isSelected, extraClassName, format } = this.props;

    const clazzNames = classNames(extraClassName, 'cs-cell', {
      'cs-cell-editing': isEditing,
      'cs-cell-selected': isSelected,
    });

    return (
      <div
        style={CellHelper.getFormatStyles(format)}
        className={clazzNames}
        onClick={this._handleClick}
      >
        {isEditing ? this._getMutable() : this._getReadOnly()}
      </div>
    );
  },

  _handleClick() {
    const { isEditing, isSelected, onSelect, onStartEdit } = this.props;

    if (!isEditing && !isSelected) {
      onSelect();
    } else if (isSelected && !isEditing) {
      onStartEdit();
    }
  },

  _getCellText() {
    return this.props.text;
  },

  _getReadOnly() {
    const { allowMarkdown, keyPrefix, placeholder } = this.props;
    let text = this._getCellText() || placeholder;

    if (allowMarkdown) {
      let content = text
        ? CellHelper.getFormattedMarkdownContent(markdownOptions, text)
        : placeholder;

      return (
        <div
          key={keyPrefix + '-md'}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      );
    }

    return <LineBreakText>{text}</LineBreakText>;
  },

  _getMutable() {
    return (
      <ResizingTextarea
        allowEditingOffViewport={this.props.allowEditingOffViewport}
        styles={this.props.textAreaStyles || {}}
        resize={this.props.resizeWhenEditing}
        onTextChanged={this._handleTextChanged}
      >
        {this._getCellText()}
      </ResizingTextarea>
    );
  },

  _handleTextChanged(heightAndText) {
    let { onStopEdit } = this.props;
    onStopEdit(heightAndText);
  },
});
